import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from '../localization/translation-en.json';
import translationAZ from '../localization/translation-az.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  az: {
    translation: translationAZ
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'az'],
    detection: {
      // remember the visitor's choice; English stays the default for first-time visitors
      order: ['localStorage'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

// keep <html lang> in sync for screen readers and search engines
document.documentElement.lang = i18n.resolvedLanguage || 'en';
i18n.on('languageChanged', lng => {
  document.documentElement.lang = lng;
});

export default i18n;
